import { Table } from '@devexpress/dx-react-grid-bootstrap4'

interface SortableTableCellProps {
  draggableColumnName: string
  value: any
  tableCellProps: any
}

const SortableTableCell: React.FunctionComponent<SortableTableCellProps> = (
  props: SortableTableCellProps,
) => {
  return props.tableCellProps.column.name !== props.draggableColumnName ? (
    <Table.Cell {...props.tableCellProps} value={props.value} />
  ) : null
}

export default SortableTableCell
